import { render, staticRenderFns } from "./resetPwdWay.vue?vue&type=template&id=5accf71c"
import script from "./resetPwdWay.vue?vue&type=script&lang=js"
export * from "./resetPwdWay.vue?vue&type=script&lang=js"
import style0 from "./resetPwdWay.vue?vue&type=style&index=0&id=5accf71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports